import { Shadow, Text, VStack } from '@genial/components';
import { useBreakpointValue, Utils } from '@genial/utils';
import { Center } from 'native-base';
import React from 'react';
import { ActivityIndicator, Modal } from 'react-native';

import { useDownloadFileWithScreenLock } from '../../../../hooks/useDownloadFileWithScreenLock';
import { DocumentsCenterLinkList } from '../../constants';
import { DocumentsCenterItem } from '../DocumentsCenterItem';

interface DocumentsCenterListProps {
  data: DocumentsCenterLinkList;
}
export const DocumentsCenterList: React.FC<DocumentsCenterListProps> = ({ data }) => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const { openFileAnotherTab, isLoading } = useDownloadFileWithScreenLock();

  const handleOpenFile = (url: string) => {
    openFileAnotherTab(url);
  };

  return (
    <Shadow level={1} borderRadius="sm" padding="inline.xxs">
      <VStack space="stack.xxxs">
        {data.map((item) => (
          <DocumentsCenterItem
            key={item.title}
            isMobile={isMobile}
            onOpenFile={handleOpenFile}
            {...item}
          />
        ))}
      </VStack>
      <Modal visible={isLoading} transparent>
        <Center flex={1} backgroundColor={Utils.ColorToken.WithOpacity('neutral.darkest', 0.3)}>
          <Shadow level={1} borderRadius="sm" padding="inline.xxxs">
            <VStack space="stack.xxxs">
              <ActivityIndicator size="large" />
              <Text>Seu download está sendo processado</Text>
            </VStack>
          </Shadow>
        </Center>
      </Modal>
    </Shadow>
  );
};
